/*
 * Copyright (c) Dito Technologies LLC
 */

import React, {Dispatch} from "react";
import {createFragmentContainer} from "react-relay";
import styles from "./StaffSelectPage.module.scss";
import StaffSelectPageOverlay from "ui/feature/root/staff-select/StaffSelectPageOverlay";
import {Action, State} from "ui/feature/root/FormReducer";
import StaffSelectPageTools from "ui/feature/root/staff-select/StaffSelectPageTools";
import {graphql} from "babel-plugin-relay/macro";
import {StaffSelectPage_sheet$data} from "ui/feature/root/staff-select/__generated__/StaffSelectPage_sheet.graphql";

interface Props {
    dispatch: Dispatch<Action>;
    state: State;
    sheet: StaffSelectPage_sheet$data;
}

const StaffSelectPage: React.FC<Props> = ({state, dispatch, sheet}) => {
    return (
        <div className={styles.container}>
            <div>
                <StaffSelectPageTools
                    dispatch={dispatch}
                    page={sheet}
                    className={styles.tools}
                    state={state}/>
                <StaffSelectPageOverlay
                    state={state}
                    dispatch={dispatch}
                    sheet={sheet}/>
            </div>
            <img
                alt={"Sheet Music Page"}
                src={sheet.thumbnail_download_url}
                className={styles.img}/>
        </div>
    )
}

export default createFragmentContainer(StaffSelectPage, {
    sheet: graphql`
    fragment StaffSelectPage_sheet on MusicSheet {
        id
        thumbnail_download_url
        ...StaffSelectPageOverlay_sheet
        ...StaffSelectPageTools_sheet
    }
    `
});
